var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBook(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 5C7 4.44772 7.44772 4 8 4H25V23C25 24.1046 24.1046 25 23 25H7V5Z",
    fill: "#CCE5FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.666 28H7.66602C7.11373 28 6.66602 27.5523 6.66602 27C6.66602 25.3431 8.00916 24 9.66602 24H23.9993V26.6667C23.9993 27.403 23.4024 28 22.666 28Z",
    fill: "#CCE5FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.33268 4.5H23.9993V3.5H9.33268V4.5ZM24.8327 5.33333V22.6667H25.8327V5.33333H24.8327ZM7.16602 27V6.66667H6.16602V27H7.16602ZM7.66602 28.5H22.666V27.5H7.66602V28.5ZM23.9993 23.5H9.66602V24.5H23.9993V23.5ZM24.4993 26.6667V24H23.4993V26.6667H24.4993ZM22.666 28.5C23.6785 28.5 24.4993 27.6792 24.4993 26.6667H23.4993C23.4993 27.1269 23.1263 27.5 22.666 27.5V28.5ZM7.16602 27C7.16602 25.6193 8.2853 24.5 9.66602 24.5V23.5C7.73302 23.5 6.16602 25.067 6.16602 27H7.16602ZM24.8327 22.6667C24.8327 23.1269 24.4596 23.5 23.9993 23.5V24.5C25.0119 24.5 25.8327 23.6792 25.8327 22.6667H24.8327ZM23.9993 4.5C24.4596 4.5 24.8327 4.8731 24.8327 5.33333H25.8327C25.8327 4.32081 25.0119 3.5 23.9993 3.5V4.5ZM6.16602 27C6.16602 27.8284 6.83759 28.5 7.66602 28.5V27.5C7.38987 27.5 7.16602 27.2761 7.16602 27H6.16602ZM9.33268 3.5C7.58378 3.5 6.16602 4.91777 6.16602 6.66667H7.16602C7.16602 5.47005 8.13607 4.5 9.33268 4.5V3.5Z",
    fill: "#14181F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBook);
export default __webpack_public_path__ + "static/media/book.a58feca7dcf98cb67a6457fbfa94c65c.svg";
export { ForwardRef as ReactComponent };